import { Box } from "@mui/material";
import BreakdownBars from "../components/BreakdownBars";
import Card, { CardGrid } from "../components/Card";
import KpiTile from "../components/KpiTile";
import SeriesChart from "../components/SeriesChart";
import StatTable from "../components/StatTable";
import StatsGate from "../components/StatsGate";
import { formatPercent } from "../format";
import { Moments, TabProps } from "../types";
import { useStats } from "../useStats";

export default function MomentsTab({ query, reloadKey }: TabProps) {
  const state = useStats<Moments>("/moments", query, reloadKey);
  return (
    <StatsGate state={state}>
      {(data, envelope) => (
        <>
          <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, mb: 2 }}>
            <KpiTile label="Download success rate" value={data.downloads.successRate} format={formatPercent} />
          </Box>
          <CardGrid>
            <Card title="Moments created" wide>
              <SeriesChart points={data.created} bucket={envelope.filters.bucket ?? "day"}
                lines={[{ key: "userCreated", label: "By fans" }, { key: "systemCreated", label: "Automatic" }]} />
            </Card>
            <Card title="Bookmarks and shares" wide>
              <SeriesChart points={data.interactions} bucket={envelope.filters.bucket ?? "day"}
                lines={[{ key: "bookmarks", label: "Bookmarks" }, { key: "shares", label: "Shares" }]} />
            </Card>
            <Card title="By type"><BreakdownBars rows={data.byType} /></Card>
            <Card title="By status"><BreakdownBars rows={data.byStatus} /></Card>
            <Card title="Downloads by status"><BreakdownBars rows={data.downloads.byStatus} /></Card>
            <Card title="Top moments" wide>
              <StatTable
                rows={data.topMoments} getRowId={(r) => r.momentId}
                columns={[
                  { field: "title", headerName: "Moment", flex: 2 },
                  { field: "tenant", headerName: "Tenant", flex: 1 },
                  { field: "gameId", headerName: "Game", flex: 1 },
                  { field: "source", headerName: "Source", flex: 1 },
                  { field: "bookmarks", headerName: "Bookmarks", type: "number", flex: 1 },
                  { field: "shares", headerName: "Shares", type: "number", flex: 1 },
                  { field: "downloads", headerName: "Downloads", type: "number", flex: 1 },
                ]}
              />
            </Card>
          </CardGrid>
        </>
      )}
    </StatsGate>
  );
}
